import {Component} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {getProductType, PRODUCT_TYPES} from 'src/app/domain/model/product/product.model';
import CustomerPortfolioApi from 'src/app/domain/service/api/customer-portfolio.api';
import {AppEnvironmentService} from 'src/app/infrastructure/environment/app-environment/app-environment.service';
import {ProductAmountEnvironmentConfiguration} from 'src/app/infrastructure/environment/app-environment/ProductAmountEnvironmentConfiguration';
import {Router} from 'src/app/infrastructure/router/router';
import {WebPage} from 'src/app/ui/webapp/page/web.page';

@Component({
  selector: 'app-advantages',
  templateUrl: 'advantages.page.html',
})

export class AdvantagesPage extends WebPage {
  public env: AppEnvironmentService;
  private amountConfiguration: ProductAmountEnvironmentConfiguration;

  constructor(
    router: Router,
    appEnvironment: AppEnvironmentService,
    titleService: Title,
    private readonly customerPortfolioApi: CustomerPortfolioApi,
  ) {
    super(router, appEnvironment, titleService);
    this.env = appEnvironment;
  }

  public getMinAmount(): number {
    return this.amountConfiguration.minInitial;
  }

  public getMinMonthlyAmount(): number {
    return this.amountConfiguration.minMonthly;
  }

  public getInsuranceAmount(): number {
    return this.amountConfiguration.insuranceBenefitAmount;
  }

  protected onInit() {
    this.amountConfiguration = this.env.getProductAmountConfiguration(PRODUCT_TYPES.unitLinked, null);

    this.subscribe(this.customerPortfolioApi.selected(), (portfolio) => {
      this.amountConfiguration = this.env.getProductAmountConfiguration(getProductType(portfolio?.productId), portfolio?.productId);
    });
  }
}
